import {
  IStatusHistory,
  ShipmentStatus,
} from '../../../../../models/parcelDeliveryMiles';
import ParcelHistoryItem from './parcel-history-item.component';
import { getStatusProgress } from './parcel-history.helpers';

interface Props {
  statusHistory: IStatusHistory[] | null;
  currentStatus: ShipmentStatus | null;
}

const ParcelHistory = ({ statusHistory, currentStatus }: Props) => {
  if (!statusHistory || !currentStatus) return;

  const historyItemsToDisplay = statusHistory.filter((s) => !!s.created_at);

  if (!historyItemsToDisplay) return;

  return (
    <>
      {historyItemsToDisplay.map(({ status, tracking }) => (
        <ParcelHistoryItem
          key={status}
          status={status}
          isLast={
            historyItemsToDisplay.findIndex((s) => s.status === status) ===
            historyItemsToDisplay.length - 1
          }
          progress={getStatusProgress(
            historyItemsToDisplay.findIndex((s) => s.status === status),
            historyItemsToDisplay.findIndex((s) => s.status === currentStatus),
            historyItemsToDisplay.length - 1
          )}
          trackingItems={tracking}
        />
      ))}
    </>
  );
};

export default ParcelHistory;
